import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LayoutList = createReactComponent("LayoutList", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "14",
  width: "7",
  height: "7",
  key: "aud0k0"
}], ["rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "7",
  key: "ikfx8m"
}], ["line", {
  x1: "14",
  y1: "4",
  x2: "21",
  y2: "4",
  key: "1m2r3u"
}], ["line", {
  x1: "14",
  y1: "9",
  x2: "21",
  y2: "9",
  key: "1l7vvx"
}], ["line", {
  x1: "14",
  y1: "15",
  x2: "21",
  y2: "15",
  key: "l5vdpy"
}], ["line", {
  x1: "14",
  y1: "20",
  x2: "21",
  y2: "20",
  key: "orewdy"
}]]]);
export default LayoutList;